import { isValidPhoneNumber } from 'libphonenumber-js'

const address = (rule, value, callback) => {
  if (!value) {
    callback(new Error('La dirección es requerida'))
  } else if (!value.number) {
    callback(new Error('La dirección está incompleta'))
  } else {
    callback()
  }
}

const name = (rule, value, callback) => {
  if (!value) {
    callback(new Error('El nombre es requerido'))
  } else {
    callback()
  }
}

const phone = (rule, value, callback) => {
  if (!value) {
    callback(new Error('El teléfono es requerido'))
  } else if (!isValidPhoneNumber(value, 'AR')) {
    callback(new Error('El teléfono no es válido'))
  } else {
    callback()
  }
}

const identification = (rule, value, callback) => {
  if (!value) {
    callback(new Error('El DNI es requerido'))
  } if (!/^\d{7,9}$/.test(value)) {
    callback(new Error('El DNI no es válido'))
  } else {
    callback()
  }
}

const fiscal = (rule, value, callback) => {
  if (!value) {
    callback(new Error('La condición fiscal es requerida'))
  } else {
    callback()
  }
}

const vehicleType = (rule, value, callback) => {
  if (!value) {
    callback(new Error('El tipo de vehículo es requerido'))
  } else {
    callback()
  }
}

const shift = (rule, value, callback) => {
  if (!value) {
    callback(new Error('La disponibilidad es requerida'))
  } else {
    callback()
  }
}

export default {
  address,
  name,
  phone,
  identification,
  fiscal,
  vehicleType,
  shift,
}
